export default "__VITE_ASSET__b4b71bd7__"